// Select2初期化スクリプト（管理画面用）
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.min.css';

// DOMContentLoaded時の初期化
document.addEventListener('DOMContentLoaded', function() {
  initSelect2();
});

// Turbo対応（ページ遷移時の初期化）
document.addEventListener('turbo:load', function() {
  initSelect2();
});

// HTMXでモーダルが開かれた後の初期化
document.body.addEventListener('htmx:afterSettle', function(event) {
  const target = event.detail.target;
  if (target && (target.id === 'global-modal' || target.closest('#global-modal'))) {
    // 少し遅延させてから初期化（モーダルのDOMが完全に構築されるまで待つ）
    setTimeout(function() {
      initSelect2();
    }, 100);
  }
});

// Bootstrap モーダルが表示された後の初期化
$(document).on('shown.bs.modal', '#global-modal', function() {
  initSelect2();
});

/**
 * Select2を初期化する関数
 */
function initSelect2() {
  // 既存のSelect2を破棄
  $('.select2-parent').each(function() {
    if ($(this).hasClass('select2-hidden-accessible')) {
      $(this).select2('destroy');
    }
  });

  // 新たにSelect2を初期化
  $('.select2-parent').select2({
    placeholder: '検索して選択...',
    allowClear: true,
    width: '100%',
    language: 'ja',
    dropdownParent: $('#global-modal').length > 0 ? $('#global-modal') : $('body')
  });
}

// jQueryとSelect2をグローバルに公開（必要に応じて）
window.$ = window.jQuery = $;

